<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="12">
              <b-tabs content-class="mt-3">
                <b-tab
                  :title="lang.name"
                  v-for="lang in languages"
                  :key="lang.id"
                >
                  <!-- .title -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-7"
                      :label="$t('pages.title')"
                      label-for="input-7"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="title"
                        vid="title"
                        rules="required"
                      >
                        <b-form-input
                          id="input-7"
                          v-model="title[lang.code]"
                          type="text"
                          :placeholder="$t('pages.title')"
                          :state="errors.length > 0 ? false : null"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- .content -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-8"
                      :label="$t('pages.content')"
                      label-for="input-8"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="content"
                        vid="content"
                        rules="required"
                      >
                        <ckeditor
                          :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                          id="input-8"
                          v-model="content[lang.code]"
                        >
                        </ckeditor>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col lg="12">
                    <b-form-group
                      id="input-group-9"
                      :label="$t('pages.button')"
                      label-for="input-9"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="button"
                        vid="button"
                      >
                        <b-form-input
                          id="input-9"
                          v-model="button[lang.code]"
                          type="text"
                          :placeholder="$t('pages.button')"
                          :state="errors.length > 0 ? false : null"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col lg="12">
                    <b-form-group
                      id="input-group-10"
                      :label="$t('pages.button_url')"
                      label-for="input-10"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="button_url"
                        vid="button_url"
                      >
                        <b-form-input
                          id="input-10"
                          v-model="button_url[lang.code]"
                          type="text"
                          :placeholder="$t('pages.button_url')"
                          :state="errors.length > 0 ? false : null"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>


                 
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <!-- .status -->
            <!-- <b-col lg="4">
              <b-form-group
                id="input-group-1"
                :label="$t('site.status')"
                label-for="input-1"
              >
                <b-form-checkbox
                  class="custom-control-primary"
                  name="check-button"
                  v-model="newItem.status"
                  value="1"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </b-form-group>
            </b-col> -->

            <!-- .image -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('news.image')"
                label-for="input-4"
              >
                <b-form-file
                  v-model="newItem.image"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/SliderController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import LanguagesController from "@/Controllers/LanguagesController";
export default {
  name: "PagesForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      youtube: [],
      languages: [],
      title: {},
      content: {},
      button: {},
      button_url : {}
    };
  },
  async created() {
    this.languages = await new LanguagesController().GetActivelanguages();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.languages.forEach((element) => {
        this.newItem[element.code] = {
          title: this.title[element.code],
          content: this.content[element.code],
          button: this.button[element.code],
          button_url: this.button_url[element.code]
        };
      });
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
  watch: {
    newItem(old) {
      
      this.languages.forEach((element) => {
        let locale = old.translations.find((a) => a.locale == element.code);

        this.$set(this.title, element.code, locale.title);
        this.$set(this.content, element.code, locale.content);
        this.$set(this.button, element.code, locale.button);
        this.$set(this.button_url, element.code, locale.button_url);
      });
    },
  },
};
</script>

